export default "__VITE_ASSET__DhL_VLv0__"